import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export function frequency({ cycle, lowercase = false }) {
    const cycleDict = {
        0: 'One-Time',
        1: 'Every Day',
        7: 'Weekly',
        14: 'Bi-Weekly',
        28: 'Monthly',
        56: 'Bi-Monthly',
        84: 'Quarterly',
    };

    const text = cycleDict[cycle] || `Every ${cycle} Days`;
    return lowercase ? _.toLower(text) : text;
}
